import styled from 'styled-components';

export default styled.p`
  font-size: 14px;
  margin: 0 0 35px;
`;
